import Image from "next/image";

export default function NextImageWrapper({ className, src, alt }: { className?: string, src: string, alt: string}) {
    return (
        <div className={`relative ${className}`}>
            <Image src={src} alt={alt} fill={true} />
        </div>
    )
}
